<template>
  <div>
    <HeaderLayout></HeaderLayout>

    <div class="app-home-table">
      <div class="table-name">
        <div class="title">
          <span>Coa {{ $t('view.list') }}</span>
        </div>
        
        <div class="option">
          <el-button
            type="primary"
            v-if="getNewShow()"
            @click="newHandle">
            <template>
              <i class="el-icon-plus"></i>
              <span>New</span>
            </template>
          </el-button>
        </div>
        
      </div>

      <el-row style="padding: 10px;clear:both">
        <el-col :span="5">
          <span>Product Name：</span>
          <el-autocomplete
            clearable
            v-model="params.productName"
            :fetch-suggestions="productNameSearch"
            placeholder="Please Input"
            popper-class="select-option"
            :popper-append-to-body="false"
            @input="handleSelectName"
          ></el-autocomplete>
        </el-col>
        <el-col :span="5">
          <div>
            <span>Item Code：</span>
            <el-autocomplete
              popper-class="select-option"
              :popper-append-to-body="false"
              clearable
              v-model="params.itemCode"
              :fetch-suggestions="itemCodeSearch"
              placeholder="Please Input"
              @input="handleSelectCode"
            ></el-autocomplete>
          </div>
        </el-col>
        <el-col :span="4">
          <span>Lot #：</span>
          <el-autocomplete
            clearable
            v-model="params.lot"
            :fetch-suggestions="lotSearch"
            placeholder="Please Input"
            popper-class="select-option"
            :popper-append-to-body="false"
            @input="handleSelectLot"
          ></el-autocomplete>
        </el-col>
        
        <el-col :span="3">
          <div style="margin-right: 20px">
            <el-radio-group
              v-model="dataType"
              size="medium"
              @change="dataTypeChange"
            > 
              <el-radio-button label="COA"></el-radio-button>
              <el-radio-button label="COA Archive"></el-radio-button>
            </el-radio-group>
          </div>
        </el-col>
        <el-col :span="6">
          <div>
            <el-button
              @click="handleSearch('查询')"
              type="primary"
              style="float: left"
              >Search</el-button>
            <el-button @click="resetSearch('重置')" style="float: left">Reset</el-button>
            <el-upload
              ref="uploadRef"
              action=""
              :auto-upload="false"
              :on-change="onChange"
              :limit="1"
              :show-file-list="false"
              style="float: left; margin: 0px 0px 0px 10px"
            >
              <el-button type="success" :loading="uploadLoading">
                {{ uploadLoading ? 'Uploading...' : 'Upload' }}
              </el-button>
            </el-upload>
            <el-button @click="showPdf()" type="primary" style="float: left;margin-left:10px;">Upload PDF</el-button>
          </div>
        </el-col>
      </el-row>

      <el-row style="padding: 10px;margin-left:50px;" v-if="selectCoaIdList.length>0 && userInfo.operateStatus && isShowBtn">        
        <el-col :span="2">
          <div>
            <el-button type="primary" @click="addToLibrary">Upload to ERP Library</el-button>
          </div>
        </el-col>
      </el-row>
      </div>

    <div class="sds-list">
      <el-table
        :data="tableData"
        border
        stripe
        v-loading="loading"
        element-loading-text="Data Is Loading..."
        height="70vh"
        style="margin-top: 10px"
      >
        <el-table-column
          type="index"
          :label="this.$t('list.number')"
          width="80"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="tyNumber"
          :label="this.$t('list.ty_number')"
          width="120"
          align="center"
          v-if="showColumn('en',true)"
        >
        <template slot-scope="scope">
          <el-input v-model="scope.row.tyNumber" v-if="scope.row.isEdit"></el-input>
          <span v-else>{{ scope.row.tyNumber }}</span>
        </template>
        </el-table-column>
        <el-table-column
          prop="itemCode"
          :label="this.$t('list.item_code')"
          width="180"
        >
        </el-table-column>
        <el-table-column
          prop="productName"
          :label="this.$t('list.product_name')"
          width="320"
        >
        </el-table-column>
        <el-table-column
          prop="lot"
          :label="this.$t('list.lot_number')"
          width="200"
        >
        </el-table-column>
        <el-table-column
          prop="chinaLot"
          :label="this.$t('list.china_lot')"
          width="140"
          align="center"
          v-if="showColumn('en',true)"
        >
        <template slot-scope="scope">
          <el-input v-model="scope.row.chinaLot" v-if="scope.row.isEdit"></el-input>
          <span v-else>{{ scope.row.chinaLot }}</span>
        </template>
        </el-table-column>
        <el-table-column
          prop="po_number"
          :label="this.$t('list.po_number')"
          width="140"
          align="center"
          v-if="showColumn('cn',true)"
        >
        <template slot-scope="scope">
          <el-input v-model="scope.row.poNumber" v-if="scope.row.isEdit"></el-input>
          <span v-else>{{ scope.row.poNumber }}</span>
        </template>
        </el-table-column>

        <el-table-column
          prop="verified"
          :label="this.$t('list.verify')"
          align="center"
          width="60"
        >
          <template slot-scope="scope">
            <i
              :class="verify_show(scope.row).icon"
              :style="{ color: verify_show(scope.row).color }"
            ></i>
          </template>
        </el-table-column>
        
        
        <el-table-column
          prop="qty"
          :label="this.$t('list.quantity')"
          width="100"
          align="center"
          v-if="showColumn('en',true)"
        >
        <template slot-scope="scope">
          <el-input v-model="scope.row.qty" v-if="scope.row.isEdit"></el-input>
          <span v-else>{{ scope.row.qty }}</span>
        </template>
        </el-table-column>
        <el-table-column
          prop="shippingMethod"
          :label="this.$t('list.shipping_method')"
          width="140"
          align="center"
          v-if="showColumn('en',true)"
        >
        <template slot-scope="scope">
          <el-input v-model="scope.row.shippingMethod" v-if="scope.row.isEdit"></el-input>
          <span v-else>{{ scope.row.shippingMethod }}</span>
        </template>
        </el-table-column>
        <!-- <el-table-column
          prop="shipmentDate"
          :label="this.$t('list.shipment_date')"
          width="180"
          align="center"
          v-if="showColumn('en',true)"
        >
        <template slot-scope="scope">
          <el-date-picker 
            v-model="scope.row.shipmentDate" 
            v-if="scope.row.isEdit" 
            type="date" 
            placeholder="选择日期"
            :default-value="getDefaultDateValue(scope.row.shipmentDate)">
          </el-date-picker>
          <span v-else>{{ getFormatterTime(scope.row.shipmentDate) }}</span>
          </template>
        </el-table-column> -->
        <el-table-column
          prop="createTime"
          :label="this.$t('list.create_time')"
          width="160"
          align="center"
          v-if="showColumn('cn',true)"
        >
          <template slot-scope="scope">
            <span>{{ getFormatterTime(scope.row.createTime) }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="verifiedTime"
          :label="this.$t('list.verified_time')"
          width="120"
          align="center"
          v-if="showColumn('cn',true)"
        >
          <template slot-scope="scope">
            <span>{{ getFormatterTime(scope.row.verifiedTime) }}</span>
          </template>
        </el-table-column>

        <el-table-column
          prop="chinaVerified"
          :label="this.$t('list.china_verify')"
          align="center"
          width="80"
          v-if="showColumn('cn',true)"
        >
          <template slot-scope="scope">
            <i
              :class="chinaVerify_show(scope.row).icon"
              :style="{ color: chinaVerify_show(scope.row).color }"
            ></i>
          </template>
        </el-table-column>
        <el-table-column
          prop="verifiedTime"
          :label="this.$t('list.china_verified_time')"
          width="140"
          align="center"
          v-if="showColumn('cn',true)"
        >
          <template slot-scope="scope">
            <span>{{ getFormatterTime(scope.row.chinaVerifiedTime) }}</span>
          </template>
        </el-table-column>
        <el-table-column
          :label="this.$t('action.action')"
          fixed="right"
          width="320"
          align="center"
        >
          <template slot-scope="scope">
            <el-button
              type="primary"
              plain
              size="mini"
              @click="editRowHandle(scope.row)"
              v-if="!scope.row.isEdit"
              >{{ labelText("edit") }}</el-button
            >
    
            <el-button
              type="warning"
              plain
              size="mini"
              @click="rowEditHandle(scope.row)"
              v-if="!getAuthShow() && !scope.row.isEdit"
              >{{ labelText("row_edit") }}</el-button
            >
            <el-button  plain size="mini" type="primary" @click="saveRowEdit(scope.row)" v-if="scope.row.isEdit">Save</el-button>
            <el-button plain size="mini" type="warning" @click="cancelRowEdit(scope.row)" v-if="scope.row.isEdit">Cancel</el-button>
            <el-button
            type="success"
            plain
            size="mini"
            @click="copyRowHandle(scope.row)"
            v-if="!getAuthShow() && !scope.row.isEdit"
            >{{ $t('action.copy') }}</el-button
          >
          <el-button
            type="danger"
            plain
            size="mini"
            v-if="!getAuthShow() && !scope.row.isEdit"
            @click="deleteRowHandle(scope.row.id)"
            
            >{{ $t('action.delete') }}</el-button
          >
          </template>
        </el-table-column>
      </el-table>

      <div class="table-pagition">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="params.pageIndex"
          :page-sizes="[30, 100, 200, 300, 400]"
          :page-size="params.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import base from "@/common/base.js";
import * as mappingUtils from "../spec/config/sdsMapping";
import * as keyConvertUtils from "../spec/config/jsonKeyConverter";
import { apiServer } from "@/network/modules/detail-api";
import HeaderLayout from "@/views/Home/layout/HeaderLayout.vue";
export default {
  components: {
    HeaderLayout,
  },
  watch: {
    // 监听路由参数变化
    '$route.query': {
      handler(newQuery, oldQuery) {
        // 当URL参数发生变化时，重新处理参数并查询
        console.info('路由参数变化:', newQuery, oldQuery);
        this.handleUrlParams();
        this.getListData();
      },
      deep: true,
      immediate: false
    }
  },
  computed: {
    isAdminAuth() {
      const userInfo = JSON.parse(localStorage.getItem('specUserInfo'));
      const nickname = userInfo.username;
      const role = userInfo.roleId;
      console.info("role:",role)
      return !(
        this.username === "JamesChen" ||
        this.username === "admin" ||
        this.username === "JiaZhang"||
        this.username === "rluo@dracoherbs.com"||
        nickname === "Richard Li"||
        role === 1
      );
    },
    labelText() {
      // 获取标签文本
      return function (text) {
        if (this.$route.query.language === "EN") {
          return keyConvertUtils.convertToTitleCase(text);
        }
        return mappingUtils.getValueByKey(text);
      };
    },
    showColumn() {
      return function(showLang,show){
        let lang = localStorage.getItem('language').toLocaleLowerCase();
        if(lang=='zh'){
          lang = 'cn';
        }
        if(showLang == lang){
          return show;
        }
        return false;
      }
    },
  },
  data() {
    return {
      loading: false, //数据加载中
      uploadLoading: false, //文件上传中
      language: "EN",
      username: "JamesChen",
      tableData: [], //表格数据
      dataType:"",
      total: 0, //总数
      suggestionsList: {
        productName: [],
        itemCode: [],
        lot: [],
      },
      searchData:{
        name:"",
        lot:"",
        code:""
      },
      params: {
        //页面参数
        pageIndex: 1,
        pageSorts: [
          {
            column: "createTime",
            asc: false,
          },
        ],
        pageSize: 30,
        itemCode: "",
        lot: "",
        productName: "",
        verifiedList: 0,
      },
      selectCoaIdList: [],
      userInfo: {
        operateStatus: false
      },
      isShowBtn: false,
    };
  },
  created() {
    // this.language = localStorage.getItem("language");
    this.getSuggestionsListData();
  },
  mounted() {
    // 加载数据
    this.params.itemCode = "";
    this.params.productName = "";
    this.params.pageIndex = 1;
    
    // 处理URL参数中的itemcode
    this.handleUrlParams();
    
    this.getListData();
  },
  methods: {
    getNewShow(){
      let userInfo = JSON.parse(localStorage.getItem("specUserInfo"));
      return userInfo.roleId==2||userInfo.roleId==1||userInfo.roleId==4;
    },
    // 处理URL参数
    handleUrlParams() {
      const urlParams = this.$route.query;
      console.info('URL参数:', urlParams);
      
      // 如果URL中有itemcode参数，设置到查询条件中
      if (urlParams.itemcode) {
        this.params.itemCode = urlParams.itemcode;
        console.info('从URL获取itemCode:', urlParams.itemcode);
      }
      
      // 如果有其他URL参数也可以在这里处理，比如productName、lot等
      if (urlParams.productName) {
        this.params.productName = urlParams.productName;
      }
      
      if (urlParams.lot) {
        this.params.lot = urlParams.lot;
      }
    },
    getAuthShow(){
      return base.getAuthShow();
    },
    rowEditHandle(row){
      console.info("row:",row)
      // 如果shipmentDate为空或无效，设置为当前年份的第一天
      if (!row.shipmentDate || row.shipmentDate === '1900-01-01 00:00:00' || row.shipmentDate === '') {
        const currentYear = new Date().getFullYear();
        row.shipmentDate = new Date(currentYear, 0, 1); // 当前年份的1月1日
      }
      row.isEdit = true;
    },
    saveRowEdit(row){
      console.info("row:",row)
      row.isEdit = false;
      let params = {
        rowId:row.id,
        tyNumber:row.tyNumber,
        chinaLot:row.chinaLot,
        quantity:row.qty,
        shippingMethod:row.shippingMethod,
        shipmentDate:row.shipmentDate,
      }
      apiServer.getDataByType("coa", "updateRow", params, (data) => {
        console.info("data:",data)
        this.$message({ type: "success", message: "Save SuccessFully" });
      });
    },
    cancelRowEdit(row){
      console.info("row:",row)
      row.isEdit = false;
    },
    handleSearch(){
      this.getListData();
    },
    resetSearch(){
      this.params.pageIndex = 1;
      this.params.productName = "";
      this.params.lot = "";
      this.params.itemCode = "";
      this.getListData();
    },
    productNameSearch(query, callback){
      const results = this.suggestionsSearch(query,this.suggestionsList.productName);
      callback(results);
    },
    itemCodeSearch(query, callback){
      const results = this.suggestionsSearch(query,this.suggestionsList.itemCode);
      callback(results);
    },
    lotSearch(query, callback){
      const results = this.suggestionsSearch(query,this.suggestionsList.lot);
      callback(results);
    },
    suggestionsSearch(queryString,searchList){
      let list = [];
      searchList.forEach((element) => {
        list.push({ value: element });
      });
      let results = queryString
        ? list.filter(this.createFilter(queryString))
        : list;
      return results;
    },
    createFilter(queryString) {
      return (restaurant) => {
        return (
          restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) !=
            -1 || restaurant.value.indexOf(queryString) != -1
        );
      };
    },
    newHandle(){
      let language = localStorage.getItem("language");
      this.$router.push({
        path: "detail",
        query: { type: "coa", language },
      });
    },
    nameSearch(){},
    handleSelectName(){},
    handleSelectLot(){},
    codeSearch(){},
    handleSelectCode(){},
    dataTypeChange(){},
    // Excel文件上传处理
    onChange(file) {
      console.info('Selected file:', file);
      
      // 检查文件类型
      // const allowedTypes = ['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'application/vnd.ms-excel'];
      // if (!allowedTypes.includes(file.raw.type)) {
      //   this.$message.error('只支持上传 Excel 文件（.xlsx, .xls）');
      //   return;
      // }
      
      // 检查文件大小（限制为 10MB）
      const maxSize = 10 * 1024 * 1024;
      if (file.raw.size > maxSize) {
        this.$message.error('文件大小不能超过 10MB');
        return;
      }
      
      this.uploadExcelFile(file.raw);
    },
    // 上传Excel文件
    uploadExcelFile(file) {
      this.uploadLoading = true;
      
      // 获取当前用户名
      const username = localStorage.getItem('loginUserNameKey') || 'Unknown';
      
      const params = {
        file: file,
        username: username
      };
      
      apiServer.getDataByType("coa", "excelImport", params, (data) => {
        this.uploadLoading = false;
        if(data.success){
          this.$message.success(data.text);
        }
        // 清除上传组件的文件列表状态
        this.clearUploadFiles();
        // 刷新列表数据
        this.getListData();
      }).catch(error => {
        this.uploadLoading = false;
        console.error('Upload error:', error);
        this.$message.error('文件上传失败，请稍后重试');
        // 即使上传失败也要清除文件状态
        this.clearUploadFiles();
      });
    },
    // PDF上传处理（暂时为空）
    showPdf() {
      this.$message.info('PDF 上传功能开发中...');
    },
    addToLibrary() {
      this.$message.info('Upload to ERP Library 功能开发中...');
    },
    // 清除上传组件的文件状态
    clearUploadFiles() {
      // 清除el-upload组件的文件列表
      if (this.$refs.uploadRef) {
        this.$refs.uploadRef.clearFiles();
      }
      // 手动触发组件重新渲染（如果需要）
      this.$nextTick(() => {
        // 确保组件状态已经重置
        console.log('Upload component state cleared');
      });
    },
    getJsonValueByKey(json, key) {
      let jsonObj = JSON.parse(json);
      return jsonObj[key];
    },
    tableRowClassName({ rowIndex }) {
      // 行变色
      if (rowIndex === 1) {
        return "warning-row";
      } else if (rowIndex === 3) {
        return "success-row";
      }
      return "";
    },
    getSuggestionsListData(){
      apiServer.getDataByType("coa", "suggestionsList", this.params, (data) => {
        this.suggestionsList.productName = data.map(item => item.productName);
        this.suggestionsList.itemCode = data.map(item => item.itemCode);
        this.suggestionsList.lot = data.map(item => item.lot);
      });
    },
    getListData() {
      //获取数据
      this.loading = true;
      console.info("apiServer:", apiServer);
      apiServer.getDataByType("coa", "getList", this.params, (data) => {
        this.params.pageIndex = data.pageIndex;
        this.params.pageSize = data.pageSize;
        this.total = data.total;
        this.tableData = data.records.map(record => ({...record, isEdit: false}));
        this.loading = false;
      });
    },
    // 加载 itemCode 数据
    getItemCodeListData(params, callback) {
      apiServer.getDataByType("coa", "itemCodeList", params, (data) => {
        callback(data);
      });
    },
    // verify 列图标显示颜色
    verify_show(val) {
      switch (val.verified) {
        case 1:
          return { icon: "el-icon-success", color: "#67c23a" };
        case 0:
          return { icon: "el-icon-error", color: "#f56c6c" };
        default:
          return { icon: "el-icon-question", color: "#a6a9ad" };
      }
    },
    chinaVerify_show(val) {
      switch (val.chinaVerified) {
        case 1:
          return { icon: "el-icon-success", color: "#67c23a" };
        case 0:
          return { icon: "el-icon-error", color: "#f56c6c" };
        default:
          return { icon: "el-icon-question", color: "#a6a9ad" };
      }
    },
    // 格式化时间
    getFormatterTime(time) {
      if (time) {
        return time === "1900-01-01 00:00:00" ? "" : base.methods.formatTime(time, `MM-dd-yyyy`);
      } else {
        return "";
      }
    },
    // 获取日期选择器的默认值
    getDefaultDateValue(currentDate) {
      // 如果当前日期为空或无效，返回当前年份的第一天作为默认值
      if (!currentDate || currentDate === '1900-01-01 00:00:00' || currentDate === '') {
        const currentYear = new Date().getFullYear();
        return new Date(currentYear, 0, 1); // 当前年份的1月1日
      }
      return null; // 如果有有效日期，不设置默认值
    },
    // 分页方法
    handleSizeChange(val) {
      this.params.pageSize = val;
      this.getListData();
    },
    handleCurrentChange(val) {
      this.params.pageIndex = val;
      this.getListData();
    },
    editRowHandle(row) {
      let language = localStorage.getItem("language");
      this.$router.push({
        path: "detail",
        query: { id: row.id,type:"coa", isCopy: false,language },
      });
    },
    // 复制行
    copyRowHandle(row) {
      this.$confirm("This will Copy the data. Continue?", "Tips", {
        confirmButtonText: "Ok",
        cancelButtonText: "Cancel",
        distinguishCancelAndClose: true,
        type: "warning",
      }).then(() => {
        let language = localStorage.getItem("language");
        this.$router.push({
          path: "detail",
          query: { id: row.id, type:"coa", isCopy: true,language },
        });
      });
    },
    deleteRowHandle(id) {
      console.info('id:',id)
      if(this.getAuthShow()){
        this.$message('请联系管理员进行删除');
        return;
      }
      this.$confirm(this.$t('confirm.delete'), this.$t('confirm.tips'), {
        confirmButtonText: this.$t('confirm.ok'),
        cancelButtonText: this.$t('confirm.cancel'),
        distinguishCancelAndClose: true,
        type: "warning",
      }).then(() => {
        apiServer.getDataByType("coa", "delete", id, () => {
          this.getListData(this.params);
          this.$message({ type: "success", message: "Delete SuccessFully" });
        });
      });
      
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../style/spec-list.css";
.app-home-table{
  margin-top:10px;
  background: white;
}
.table-name{
  width: 100vw;
  height: 60px;
  line-height: 60px;
  border-bottom: 1px solid gainsboro;
}
.table-name .title{
  float:left;
  margin-left:40px;
}
.table-name .option{
  float:right;
  margin-right: 40px;
}
.table-name span{
  margin-right: 20px;
}
</style>